import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from '@/store'
import '../public/reset.scss'
import '@/plugins/element-ui'
import http from '@/plugins/axios'
import axios from './axios'
import * as api from './api'
import * as filters from './filters'
import * as utils from './utils'
// import VueCookies from 'vue-cookies'

// axios.defaults.withCredentials = true;跨域所用，没作用，注释
const $cookies = require('vue-cookies')
Vue.use($cookies)
Vue.prototype.$axios = axios
Vue.prototype.$api = api
Vue.prototype.$utils = utils
Object.defineProperty(Vue.prototype, '$http', { value: http })
Vue.config.productionTip = false
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
Vue.use(require('@/plugins/directive'))

router.beforeEach((to, from, next) => {
  if (to.matched.some(res => res.meta.requireAuth)) {
    // 判断是否需要登录权限
    if (store.state.global.cookie) {
      // 判断是否登录
      next()
    } else {
      // 没登录则跳转到登录界面
      next({
        path: '/',
        query: { redirect: to.fullPath }
      })
    }
  } else {
    next()
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
